import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/orderings/purchase-invoice/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const purchaseInvoices = {
  get: apiPathFunc(pathBase),
} as const;
